import { SxProps, Theme } from '@mui/material/styles';

export const gridSx: SxProps<Theme> = {
  display: 'grid',
  gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
  gap: 2,
  '@media (max-width: 376px)': {
    gridTemplateColumns: '1fr',
  },
};
